import {
  Box,
  Container,
  Typography,
  Paper,
  Fade,
  Grow,
  Chip,
  Stack,
  useTheme,
} from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { useState, useEffect } from "react";

export const AdminAuthSuccess = () => {
  const [showContent, setShowContent] = useState(false);
  const theme = useTheme();

  useEffect(() => {
    const timer = setTimeout(() => setShowContent(true), 200);
    return () => clearTimeout(timer);
  }, []);

  return (
    <Box
      sx={{
        minHeight: "100vh",
        background: `linear-gradient(135deg, ${theme.palette.primary.light}15 0%, ${theme.palette.primary.main}10 100%)`,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Container maxWidth="sm">
        <Fade in={showContent} timeout={800}>
          <Paper
            elevation={8}
            sx={{
              p: 6,
              textAlign: "center",
              borderRadius: 3,
              background: "linear-gradient(145deg, #ffffff 0%, #fafafa 100%)",
              border: `1px solid ${theme.palette.divider}`,
            }}
          >
            <Stack spacing={3} alignItems="center">
              {/* Success Icon */}
              <Grow in={showContent} timeout={1000}>
                <Box
                  sx={{
                    position: "relative",
                    display: "inline-flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <CheckCircleIcon
                    sx={{
                      fontSize: 80,
                      color: theme.palette.success.main,
                      filter: "drop-shadow(0 4px 8px rgba(76, 175, 80, 0.3))",
                    }}
                  />
                </Box>
              </Grow>

              {/* Main Heading */}
              <Fade
                in={showContent}
                timeout={1200}
                style={{ transitionDelay: "200ms" }}
              >
                <Typography
                  variant="h4"
                  fontWeight="bold"
                  sx={{
                    background: `linear-gradient(45deg, ${theme.palette.primary.main}, ${theme.palette.primary.dark})`,
                    backgroundClip: "text",
                    WebkitBackgroundClip: "text",
                    WebkitTextFillColor: "transparent",
                    mb: 1,
                  }}
                >
                  Setup Complete
                </Typography>
              </Fade>

              {/* Success Chip */}
              <Fade
                in={showContent}
                timeout={1400}
                style={{ transitionDelay: "400ms" }}
              >
                <Chip
                  label="Admin Consent Granted"
                  color="success"
                  variant="outlined"
                  sx={{
                    px: 2,
                    py: 0.5,
                    fontSize: "0.9rem",
                    fontWeight: 500,
                  }}
                />
              </Fade>

              {/* Dobby Logo */}
              <Fade
                in={showContent}
                timeout={1600}
                style={{ transitionDelay: "600ms" }}
              >
                <Box
                  component="img"
                  src="/www/assets/dobby_login_hero.png"
                  alt="Dobby Logo"
                  sx={{
                    maxWidth: 180,
                    height: "auto",
                    borderRadius: 2,
                  }}
                />
              </Fade>

              {/* Description */}
              <Fade
                in={showContent}
                timeout={1800}
                style={{ transitionDelay: "800ms" }}
              >
                <Stack spacing={2} sx={{ maxWidth: 400 }}>
                  <Typography
                    variant="body1"
                    sx={{
                      color: theme.palette.text.secondary,
                      lineHeight: 1.6,
                    }}
                  >
                    Admin consent has been granted for your organization. All
                    users in your organization can now access Dobby services.
                    You can close this window.
                  </Typography>
                </Stack>
              </Fade>

              {/* Footer */}
              <Fade
                in={showContent}
                timeout={2000}
                style={{ transitionDelay: "1000ms" }}
              >
                <Box
                  sx={{
                    mt: 4,
                    pt: 3,
                    borderTop: `1px solid ${theme.palette.divider}`,
                    width: "100%",
                  }}
                >
                  <Typography
                    variant="caption"
                    sx={{
                      color: theme.palette.text.disabled,
                      fontSize: "0.8rem",
                    }}
                  >
                    This window can be safely closed
                  </Typography>
                </Box>
              </Fade>
            </Stack>
          </Paper>
        </Fade>
      </Container>
    </Box>
  );
};
